import React from "react";
import { Link } from "react-router-dom";

import { LayzImage } from "components";

import styles from "./styles.module.css";

const CategoryCard = ({
  id,
  name,
  category_image_url,
  image,
  slug,
  vendor,
}) => {
  return (
    <Link
      to={
        vendor
          ? `/categories/single/${slug}?vendor=${vendor}`
          : `/categories/single/${slug}`
      }
    >
      <div className={styles.cat_item}>
        <LayzImage
          src={`${category_image_url}?date=${new Date().toISOString()}`}
          width={"100%"}
        />
        <span>{name}</span>
      </div>
    </Link>
  );
};

export default CategoryCard;
